<template>
  <BaseDialog :isOpen="isOpen">
    <template v-slot:title>
      {{ title }}
    </template>
    <template v-slot:body>
      <p v-if="subText">
        {{ subText }}
      </p>
    </template>
    <template v-slot:actions>
      <div>
        <PrimaryButton @click.native="close" text>
          Cancel
        </PrimaryButton>
        <ErrorButton
          @click.native="handleSubmit"
          :loading="isLoading"
          v-if="isError"
        >
          {{ buttonText }}
        </ErrorButton>
        <PrimaryButton @click.native="handleSubmit" :loading="isLoading" v-else>
          {{ buttonText }}
        </PrimaryButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import ErrorButton from "@/components/common/Button/ErrorButton";

export default {
  components: {
    PrimaryButton,
    BaseDialog,
    ErrorButton
  },
  props: {
    isOpen: Boolean,
    title: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    },
    subText: String,
    isLoading: Boolean,
    isError: Boolean
  },
  methods: {
    handleSubmit() {
      this.$emit("submit");
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
